<script lang="ts">
  import { DrawerDescription, DrawerHeader, DrawerTitle } from "$lib/ui/drawer";
  import LoadingSpinner from "$lib/ui/loading-spinner/loading-spinner.svelte";

  interface Props {
    connectionId: string;
  }

  let { connectionId }: Props = $props();
</script>

<DrawerHeader class="pt-8 px-6 pb-4 relative">
  <DrawerTitle class="text-3xl text-left">Connecting to {connectionId}</DrawerTitle>
  <DrawerDescription>
    Waiting for successful confirmation of {connectionId} access.
    <div class="h-full flex items-center justify-center">
      <LoadingSpinner />
    </div>
  </DrawerDescription>
</DrawerHeader>
<div class="flex flex-col px-6 mt-5"></div>
